/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Aggregation } from './Aggregation';
import {
    AggregationFromJSON,
    AggregationFromJSONTyped,
    AggregationToJSON,
    AggregationToJSONTyped,
} from './Aggregation';
import type { WidgetResourceRepresentation } from './WidgetResourceRepresentation';
import {
    WidgetResourceRepresentationFromJSON,
    WidgetResourceRepresentationFromJSONTyped,
    WidgetResourceRepresentationToJSON,
    WidgetResourceRepresentationToJSONTyped,
} from './WidgetResourceRepresentation';

/**
 * 
 * @export
 * @interface WidgetMetricRepresentation
 */
export interface WidgetMetricRepresentation {
    /**
     * 
     * @type {string}
     * @memberof WidgetMetricRepresentation
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetMetricRepresentation
     */
    metricKey: string;
    /**
     * 
     * @type {Aggregation}
     * @memberof WidgetMetricRepresentation
     */
    aggregationOverTime: Aggregation;
    /**
     * 
     * @type {number}
     * @memberof WidgetMetricRepresentation
     */
    position: number;
    /**
     * 
     * @type {Array<WidgetResourceRepresentation>}
     * @memberof WidgetMetricRepresentation
     */
    resources: Array<WidgetResourceRepresentation>;
}



/**
 * Check if a given object implements the WidgetMetricRepresentation interface.
 */
export function instanceOfWidgetMetricRepresentation(value: object): value is WidgetMetricRepresentation {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('metricKey' in value) || value['metricKey'] === undefined) return false;
    if (!('aggregationOverTime' in value) || value['aggregationOverTime'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('resources' in value) || value['resources'] === undefined) return false;
    return true;
}

export function WidgetMetricRepresentationFromJSON(json: any): WidgetMetricRepresentation {
    return WidgetMetricRepresentationFromJSONTyped(json, false);
}

export function WidgetMetricRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetMetricRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'metricKey': json['metricKey'],
        'aggregationOverTime': AggregationFromJSON(json['aggregationOverTime']),
        'position': json['position'],
        'resources': ((json['resources'] as Array<any>).map(WidgetResourceRepresentationFromJSON)),
    };
}

export function WidgetMetricRepresentationToJSON(json: any): WidgetMetricRepresentation {
    return WidgetMetricRepresentationToJSONTyped(json, false);
}

export function WidgetMetricRepresentationToJSONTyped(value?: WidgetMetricRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'metricKey': value['metricKey'],
        'aggregationOverTime': AggregationToJSON(value['aggregationOverTime']),
        'position': value['position'],
        'resources': ((value['resources'] as Array<any>).map(WidgetResourceRepresentationToJSON)),
    };
}

